<template>
  <div :class="formGroupClass">
    <b-form-group>
      <validation-provider
        :name="validationLabel ? validationLabel : label.toLowerCase()"
        :rules="rules"
        v-slot="validationContext"
      >
        <label :for="`label-${label}`" v-if="label">
          <span v-html="computedLabel" />
        </label>
        <multiselect
          v-model="computedInputData"
          :options="options"
          :custom-label="customLabel"
          :track-by="trackBy"
          :class="selectClassName(validationContext)"
          @focus.native="autoCompleteHandler"
          @input="inputHandler"
          :placeholder="computedPlaceholder"
          :disabled="isDisabled"
          :deselectLabel="deselectLabel"
          :selectedLabel="selectedLabel"
          :selectLabel="selectLabel"
        >
        </multiselect>
        <b-form-invalid-feedback :state="getValidationState(validationContext)">
          {{ apiErrors ? errorField[0] : validationContext.errors[0] }}
        </b-form-invalid-feedback>
      </validation-provider>
    </b-form-group>
  </div>
</template>
<script>
import { ValidationProvider } from "vee-validate";
export default {
  name: "InputSingleSelect",
  props: {
    rules: {
      type: Object,
      required: false,
      default: null,
    },
    label: {
      required: false,
    },
    placeholder: {
      type: String,
      required: false,
      default: "",
    },
    vmodel: {
      required: true,
    },
    formGroupClass: {
      type: String,
      required: false,
    },
    inputClass: {
      type: String,
      required: false,
      default: "",
    },
    options: {
      required: true,
    },
    customLabel: {
      required: false,
    },
    isDisabled: {
      required: false,
      default: false,
    },
    optionsLimit: {
      type: Number,
      default: 300,
    },
    trackBy: {
      type:String,
      required: false,
    },
    validationLabel: {
      type: String,
      required: false,
    },
    apiErrors: {
      type: Object,
      default: null,
    },
    apiErrorKey: {
      type: String,
      default: "",
    },
    deselectLabel:{
      type:String,
      default:''
    },
    selectedLabel:{
      default:''
    },
    selectLabel:{
      type:String,
      default:''
    }
  },
  components: {
    ValidationProvider,
  },
  computed: {
    computedLabel() {
      if (!this.label) {
        return "";
      }
      if (this.rules && this.rules.required) {
        return this.label + "<span class='input-required'>  *</span>";
      }
      return this.label;
    },
    computedInputData: {
      get: function () {
        return this.vmodel;
      },
      set: function (value) {
        this.$emit("update:vmodel", value);
      },
    },
    errorField() {
      return this.apiErrors ? this.apiErrors[this.apiErrorKey] : null;
    },
    computedPlaceholder() {
      if (this.placeholder) {
        return this.placeholder;
      }
      return `Select ${this.label ? this.label : "options"}`;
    },
  },
  methods: {
    inputHandler() {
      this.$emit("onInput");
    },
    selectClassName(validationContext) {
      let className = "";
      if (this.rules) {
        if (validationContext.errors[0]) {
          className = "invalid-input-block";
        } else if (validationContext.valid) {
          className = "valid-input-block";
        } else {
          className = "";
        }
      }
      return `${className} ${this.inputClass}`;
    },
    autoCompleteHandler() {
      document
        .querySelector(".multiselect__input")
        .setAttribute("autocomplete", "off");
    },
    getValidationState({ dirty, validated, valid = null }) {
      return dirty || validated ? valid : null;
    },
  },
};
</script>
<style>
.multiselect__option--selected.multiselect__option--highlight {
  background: #00ccff !important;
}
</style>